import React, { useContext, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { find, map, size } from 'underscore';
import { Link } from 'app/shared/link/link';
import { Tooltip } from 'antd';
import { Context } from 'app/index';
import { useFlying } from 'app/hooks/useFlying';
import classNames from 'classnames';
import ContentLoader from 'react-content-loader';
import { openProductModal } from '../actions/setModal';
import { TooltipText } from '../../../shared/TooltipText/TooltipText';
import { InputQty, ProductButton } from './shopModal';
import { getConsiderProductPriceByTypePrice } from '../../../functions/app';
import { Float } from '../../../functions/input-float';
import { Img } from 'app/shared/img/img';

export const ProductCardLoader = ({ height }) => {
    const width = '100%';
    return (
        <ContentLoader
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            viewBox={`0 0 500 500`}
            height={height}
            preserveAspectRatio="none"
            style={{ width }}
        >
            <rect x="0" y="16" rx="5" ry="5" width={width} height="48" />
            <rect x="0" y="74" rx="5" ry="5" width={width} height="34" />
            <rect x="0" y="118" rx="5" ry="5" width={width} height="200" />
            <rect x="0" y="328" rx="5" ry="5" width={width} height="28" />
            <rect x="0" y="366" rx="5" ry="5" width={width} height="100" />
        </ContentLoader>
    );
};

export const ProductCard = ({
    addProduct,
    removeProduct,
    product,
    shopStateProduct,
    route,
    currency,
    user,
    point,
    rowView,
    openModalProduct,
    onClick,
    className,
    destroyProduct,
    setProductQty,
}) => {
    const product_qty = (shopStateProduct ? shopStateProduct.qty : 0) || 0;
    const [focus, setFocus] = useState(false);
    const { cart } = useContext(Context);
    const qtyContainerRef = useRef();
    const fly = useFlying(cart);

    const addProductAction = (e) => {
        onDisabledButton(e);
        addProduct(product);
    };

    function addFirstProductAction(e) {
        addProductAction(e);
        if (qtyContainerRef.current && cart.current) {
            const clone = document.createElement('div');
            clone.className = 'cart-indicator';
            clone.innerText = '1';
            qtyContainerRef.current.appendChild(clone);
            fly(clone);
        }
    }

    const removeProductAction = (e) => {
        e.stopPropagation();
        Number(product_qty) - 1 <= 0
            ? destroyProduct(product.id)
            : removeProduct(product);
    };

    const onDisabledButton = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onChangeCountProduct = (e) => {
        e.stopPropagation();
        setProductQty(product.id, +Float(e.target.value, 3));
    };

    const onBlur = (e) => {
        e.stopPropagation();
        if (e.target.value <= 0) {
            destroyProduct(product.id);
        }
        setFocus(false);
    };

    const { description, name, id, type, discount, discounts } = product;
    const consideredPrice = getConsiderProductPriceByTypePrice(
        product,
        point.type_price_json,
        product_qty,
        user ? user.discount : 0
    );
    const to = `/categories/${type.id}/products/${id}`;
    return (
        <div
            className={classNames(
                'product-card',
                { 'product-card_row ': rowView },
                { 'product-card_mobile': rowView },
                className
            )}
        >
            <ProductLink
                to={to}
                onClick={(e) => {
                    if (typeof onClick === 'function') onClick(e, to);
                    openModalProduct(product);
                }}
                className={'product-card__img'}
            >
                <Img
                    rowView={rowView}
                    alt={name}
                    lazy
                    route={`${route}api/shop/images/medium/`}
                    img={product.image}
                />
            </ProductLink>
            <div className={'product-card__info'}>
                <div className={'product-card__section'}>
                    <ProductLink
                        to={to}
                        onClick={(e) => {
                            if (typeof onClick === 'function') onClick(e, to);
                            openModalProduct(product);
                        }}
                    >
                        <TooltipText
                            ellipsis={{ rows: 2, tooltip: name }}
                            className={'product-card__name'}
                        >
                            {name}
                        </TooltipText>
                    </ProductLink>
                    {description && (
                        <TooltipText
                            ellipsis={
                                rowView
                                    ? undefined
                                    : { rows: 3, tooltip: description }
                            }
                            className={'product-card__description'}
                        >
                            {description}
                        </TooltipText>
                    )}
                </div>
                <div className={'product-card__section'}>
                    <div className={'product-card__footer'}>
                        <div className={'product-card__footer__prices'}>
                            {discount || size(discounts) ? (
                                <ProductTooltip
                                    product={product}
                                    currency={currency}
                                />
                            ) : null}
                            {discount ? (
                                <div className={'product-card__oldPrice'}>
                                    {consideredPrice.price_original}
                                    {currency}
                                </div>
                            ) : null}
                        </div>
                        <div className={'product-card__stock'}>
                            {!product.total_qty ||
                            product.total_qty <= 0 ? null : (
                                <span className="mr-auto">
                                    {product.total_qty}
                                    &nbsp;
                                    {product.unit.name}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className={'product-card__prices'}>
                        <span className={'product-card__price'}>
                            {consideredPrice.price_consider}
                            {currency}
                        </span>
                        {product_qty > 0 || focus ? (
                            <InputQty
                                onFocus={() => setFocus(true)}
                                onBlur={onBlur}
                                ref={qtyContainerRef}
                                onPlus={addProductAction}
                                onMinus={removeProductAction}
                                onChange={onChangeCountProduct}
                                value={product_qty}
                            />
                        ) : (
                            <ProductButton
                                ref={qtyContainerRef}
                                onClick={addFirstProductAction}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ProductLink = ({ to, onClick, children, className }) => {
    return (
        <Link
            to={to}
            state={{ withoutModal: true }}
            onClick={onClick}
            className={className}
        >
            {children}
        </Link>
    );
};
export const ProductTooltip = ({ product, currency }) => {
    const content = (
        <div className={'product-card__discount'}>
            {size(product.discounts) ? (
                <Price
                    currency={currency}
                    discount={product.discounts[0].discount}
                    qty={product.discounts[0].qty}
                    percent={product.discounts[0].percent}
                />
            ) : (
                <>
                    -{product.discount}&thinsp;
                    {product.discount_percent ? '%' : currency}
                </>
            )}
        </div>
    );
    return size(product.discounts) ? (
        <Tooltip title={<Prices product={product} currency={currency} />}>
            {content}
        </Tooltip>
    ) : (
        content
    );
};
const Price = ({ qty, discount, currency, percent }) => {
    return (
        <>
            -{discount}&thinsp;{percent ? '%' : currency} от {qty} шт.
        </>
    );
};
const Prices = ({ product, currency }) => {
    return map(product.discounts, ({ qty, discount, percent }, index) => (
        <div key={index}>
            <Price
                percent={percent}
                currency={currency}
                discount={discount}
                qty={qty}
            />
        </div>
    ));
};

const mapStateToProps = (state, props) => {
    return {
        route: state.appState.route,
        user: state.authState.user,
        currency: state.pointsState.currency,
        shopStateProduct: find(
            state.shopState.shopCase.products,
            (product) => product.id === props.product.id
        ),
        point: state.shopState.order.point,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        addProduct: (product) => {
            dispatch({
                type: 'add_product',
                product: product,
            });
        },
        removeProduct: (product) => {
            dispatch({
                type: 'remove_product',
                product: product,
            });
        },
        destroyProduct: function (product_id) {
            dispatch({
                type: 'destroy_product',
                product_id: product_id,
            });
        },
        setProductQty: function (product_id, qty) {
            dispatch({
                type: 'set_product_qty',
                product_id: product_id,
                qty: qty,
            });
        },
        openModalProduct: (product) => {
            dispatch(openProductModal(product));
        },
        dispatch,
    };
};

export const ProductCardLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductCard);
